module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-gold.png?v=48629f6b";